import React, { useEffect, useState, useRef } from 'react';

const useSharedAnimation = (callback, speed, limit, dataCountPerFrame, isPlayer, isPlaying, curSec) => {
    
    const [index, setIndex] = useState(1);
    const requestAnimationRef = useRef(null);
    const savedCallback = useRef(callback);
    const lastTimeRef = useRef(0);
    const isAnimatingRef = useRef(false); // 중복 실행 방지용

    // 최신 callback을 저장하여 무한 재실행을 방지합니다.
    useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    // 애니메이션 로직 (dataCountPerFrame 변경 시 애니메이션을 멈추고 다시 설정)
    useEffect(() => {
        if (isAnimatingRef.current) {
            // 애니메이션이 이미 실행 중이면 종료 후 재시작
            cancelAnimationFrame(requestAnimationRef.current);
            isAnimatingRef.current = false;
        }

        // 애니메이션 시작
        const animate = (time) => {
            if (time - lastTimeRef.current >= speed) {
                if ((isPlayer && isPlaying) || !isPlayer) {
                    setIndex((prevIndex) => {
                        const newIndex = prevIndex + dataCountPerFrame;
                        if (newIndex > limit) {
                            return 1; // limit을 넘으면 1로 초기화
                        }
                        return newIndex;
                    });
                    lastTimeRef.current = time; // 마지막 애니메이션 실행 시간 업데이트
                }
            }
            requestAnimationRef.current = requestAnimationFrame(animate); // 애니메이션 반복
        };

        requestAnimationRef.current = requestAnimationFrame(animate);
        isAnimatingRef.current = true;

        return () => {
            // 애니메이션 종료
            if (requestAnimationRef.current) {
                cancelAnimationFrame(requestAnimationRef.current);
                isAnimatingRef.current = false; // 애니메이션이 종료되면 상태 업데이트
            }
        };
    }, [speed, limit, dataCountPerFrame, isPlaying, isPlayer]); // dataCountPerFrame이 변경될 때마다 애니메이션 중단 및 재시작

    useEffect(() => {
        if (isPlayer && !isPlaying && curSec === 0) {
            cancelAnimationFrame(requestAnimationRef.current);
            isAnimatingRef.current = false; // 애니메이션이 종료되면 상태 업데이트
            setIndex(1); // index를 1로 초기화
        }
    }, [isPlayer, isPlaying, curSec]);

    // index가 변할 때만 callback을 호출
    useEffect(() => {
        savedCallback.current(index);
    }, [index]);

    return index;
};

export default useSharedAnimation;